import * as Yup from "yup";

export const editValidationSchema = Yup.object().shape({
  forms: Yup.array().of(
    Yup.object().shape({
      totalRight: Yup.number()
        .required("Bu Alan Zorunlu")
        .min(1, "1'den küçük olamaz"),
      usedRight: Yup.number()
        .required("Bu Alan Zorunlu")
        .min(0, "0'dan küçük olamaz")
        .max(Yup.ref("totalRight"), "Toplam izin hakkından fazla olamaz"),
    })
  ),
});
